import httpRequest from '@/services/httpRequest.js'

export default ({
  namespaced: true,
  state: {
    isLoading: true,
    holiday: null,
    semesterData: null,
    semesterItem: null,
    scheduleData: null,
    scheduleItem: null,
    scheduleList: [],
    attendanceStudents: null,
    student: null,
    students: null,
    studentsSummary: null,
    leaveRequest: null,
    attendanceSummary: null,
    errorMessage: {},
    initializeSubjects: [],
  },
  mutations: {
    SET_SCHEDULE_DATA(state, data) {
      state.scheduleData = data
    },
    SET_ATTENDANCE_STUDENTS(state, data) {
      state.attendanceStudents = data
    },
    SET_SCHEDULE_ITEM(state, data) {
      state.scheduleItem = data
    },
    SET_SCHEDULE_LIST(state, data) {
      state.scheduleList = data
    },
    SET_STUDENT(state, data) {
      state.student = data
    },
    SET_STUDENTS(state, data) {
      state.students = data
    },
    SET_STUDENTS_SUMMARY(state, data) {
      state.studentsSummary = data
    },
    SET_LEAVE_REQUEST(state, data) {
      state.leaveRequest = data
    },
    SET_ATTENDANCE_SUMMARY(state, data) {
      state.attendanceSummary = data
    },
    SET_SEMESTER_DATA(state, data) {
      state.semesterData = data
    },
    SET_SEMESTER_ITEM(state, data) {
      state.semesterItem = data
    },
    SET_ERROR_MESSAGE(state, errorPayload) {
      if (typeof errorPayload === 'object' && errorPayload !== null) {
        state.errorMessage = { ...errorPayload };
      } else {
        state.errorMessage = { general: errorPayload };
      }
    },
    CLEAR_ERROR_MESSAGE(state, key = null) {
      if (key && typeof state.errorMessage === 'object' && state.errorMessage !== null) {
        const newErrorMessage = { ...state.errorMessage };
        delete newErrorMessage[key];
        state.errorMessage = newErrorMessage;
      } else {
        state.errorMessage = {};
      }
    },
    SET_IS_LOADING(state, status) {
      state.isLoading = status
    },
    SET_INITIALIZE_SUBJECTS(state, subjects) {
      state.initializeSubjects = subjects
    },
  },
  actions: {
    async getScheduleData({ rootState, commit }, params) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/subjectschedule`,
          method: 'GET',
          params: params
        },
        authorized: true
      }
      const res = await httpRequest(payload)
      if (res.status === 200) {
        await commit('SET_SCHEDULE_DATA', res.data)
      } else {
        //console.log('error = ', res)
      }
    },
    async getHoliday({ rootState, state }) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/subjectschedule/weekday_holiday`,
          method: 'GET',
        },
        authorized: true
      }
      const res = await httpRequest(payload)
      if (res.status === 200) {
        state.holiday = res.data
      } else {
        //console.log('error = ', res)
      }
    },
    async getAttendanceStudents({ rootState, commit }, params) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/subjectattendance`,
          method: 'GET',
          params: params
        },
        authorized: true
      }
      if (payload.options.params) {
        payload.options.params.rows = 100
      }
      const res = await httpRequest(payload)
      if (res.status === 200) {
        await commit('SET_ATTENDANCE_STUDENTS', res.data)
      } else {
        //console.log('error = ', res)
      }
    },
    async getStudents({ rootState, commit }, idSubject) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/classroom/${idSubject}/students`,
          method: 'GET',
        },
        authorized: true
      }
      const res = await httpRequest(payload)
      if (res.status === 200) {
        await commit('SET_STUDENTS', res.data)
      } else {
        //console.log('error = ', res)
      }
    },
    async getStudentsSummary({ rootState, commit }, params) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/subjectattendance/summary`,
          method: 'GET',
          params: params
        },
        authorized: true
      }
      const res = await httpRequest(payload)
      if (res.status === 200) {
        await commit('SET_STUDENTS_SUMMARY', res.data)
      } else {
        //console.log('error = ', res)
      }
    },
    async getLeaveRequest({ rootState, commit }, params) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/studentleaverequest`,
          method: 'GET',
          params: params
        },
        authorized: true
      }
      const res = await httpRequest(payload)
      if (res.status === 200) {
        await commit('SET_LEAVE_REQUEST', res.data)
      } else {
        //console.log('error = ', res)
      }
    },
    async getAttendanceSummary({ rootState, commit }, params) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/subjectattendance/student_summary`,
          method: 'GET',
          params: params
        },
        authorized: true
      }
      const res = await httpRequest(payload)
      if (res.status === 200) {
        await commit('SET_ATTENDANCE_SUMMARY', res.data)
      } else {
        //console.log('error = ', res)
      }
    },
    async getSemester({ rootState, commit }) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/semester`,
          method: 'GET',
        },
        authorized: true
      }
      const res = await httpRequest(payload)
      if (res.status === 200) {
        await commit('SET_SEMESTER_DATA', res.data)
      } else {
        //console.log('error = ', res)
      }
    },
    async editSubjectsAttendance({ rootState }, params) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/subjectattendance/${params.id}`,
          method: 'PATCH',
          data: params.data,
        },
        authorized: true
      }
      const res = await httpRequest(payload)
      if (res.status === 200) {
        return;
      } else {
        //console.log('error = ', res)
      }
    },
    async sendSubjectsAttendance({ rootState }, p) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/subjectattendance/submit`,
          method: 'POST',
          params: p.params,
          data: p.data,
        },
        authorized: true
      }
      const res = await httpRequest(payload)
      if (res.status === 200 || res.status === 201) {
        return;
      } else {
        //console.log('error = ', res)
      }
    },
    async initializeSubjectAttendance({ rootState, state, commit }, params) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/subjectattendance/initialize`,
          method: 'POST',
          data: params,
        },
        authorized: true
      }
      const res = await httpRequest(payload)
      if (res.status === 200) {
        await commit('SET_INITIALIZE_SUBJECTS', res.data)
      } else {
        await commit('SET_INITIALIZE_SUBJECTS', []);
        // state.errorMessage = res.data
        commit('SET_ERROR_MESSAGE', res.data)
        setTimeout(() => {
          commit('CLEAR_ERROR_MESSAGE');
        }, 2000);
      }

    },
  }
})